var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-breadcrumbs',{staticClass:"pa-3",attrs:{"items":_vm.breadCrumbs},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-breadcrumbs-item',{staticClass:"crumb-item",attrs:{"to":item.to,"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }